import { inject, Injectable } from '@angular/core';
import { CountryLanguages, LanguageDetailsResult } from '../../models/utils';
import { LanguageFinderService } from './language-finder.service';

@Injectable({ providedIn: 'root' })
export class LanguageRedirectorService {
  languageFinder = inject(LanguageFinderService);

  loadSelectedLanguage(
    countryCode: string,
    languageCode: string,
    countries: CountryLanguages[]
  ): void {
    const [currentCountry, currentLang] = location.pathname
      .split('/')
      .filter(Boolean);

    const isHomePage = !currentCountry && !currentLang;

    const target = this.languageFinder.findLanguageDetails(
      countryCode,
      languageCode,
      'isoCode',
      countries
    );

    const validaPath = this.languageFinder.isValidPath(
      currentCountry,
      currentLang
    );

    if (target) {
      this.redirectToUrl(
        target,
        currentCountry,
        currentLang,
        languageCode,
        validaPath,
        isHomePage
      );
    }
  }

  private redirectToUrl(
    target: LanguageDetailsResult,
    currentCountry: string,
    currentLang: string,
    targetLang: string,
    validPath: boolean,
    isHomePage: boolean
  ): void {
    if (!target.countryMatch) return;

    const url = new URL(location.href);
    if (validPath) {
      url.pathname = url.pathname.replace(
        `/${currentCountry}/${currentLang}`,
        `/${target.countryMatch.urlcc}/${targetLang}`
      );
    } else if (isHomePage) {
      url.pathname = `/${target.countryMatch.urlcc}/${targetLang}`;
    }
    url.hostname = target.languageDetails.url;
    const newUrl = url.toString();
    location.href = newUrl;
  }
}
